import { render, staticRenderFns } from "./uninstall-v1.vue?vue&type=template&id=46d54526&scoped=true&"
import script from "./uninstall-v1.vue?vue&type=script&lang=js&"
export * from "./uninstall-v1.vue?vue&type=script&lang=js&"
import style0 from "./uninstall-v1.vue?vue&type=style&index=0&id=46d54526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d54526",
  null
  
)

export default component.exports